import _ from 'underscore';

function getTextAsset(text, pinPosition) {
  return {
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Text: text,
    },
    PinnedField: pinPosition,
  };
}

function getAssets(assets) {
  const availableAssets = _.filter(assets, asset => asset.text !== '');
  return _.map(availableAssets, asset => getTextAsset(asset.text, asset.pinPosition));
}

export class AdStrengthRepository {
  constructor({
    adId,
    edm,
    jsdata,
  }) {
    this.adId = adId;
    this.edm = edm;
    this.jsdata = jsdata;
  }

  fetchAdStrength(viewModel) {
    const headlines = _.map(_.range(15), i => ({
      text: _.result(viewModel, `Headline${i}`),
      pinPosition: _.result(viewModel, `Headline${i}Position`),
    }));
    const descriptions = _.map(_.range(4), i => ({
      text: _.result(viewModel, `Description${i}`),
      pinPosition: _.result(viewModel, `Description${i}Position`),
    }));

    const params = this.edm.currentAccount ? {
      query: {
        entitySet: this.edm.currentAccount
          .Ads['Default.GetAdStrengthAndActionItems']
          .$call({
            ad: {
              '@odata.type': '#Model.ResponsiveSearchAd',
              Type: 'ResponsiveSearch',
              adId: this.adId,
              Headlines: getAssets(headlines),
              Descriptions: getAssets(descriptions),
            },
          })
          .toJSON(),
      },
    } : {
      query: {
        entitySet: this.edm.currentCustomer
          .Accounts.$withKey(viewModel.accountId)
          .Ads['Default.GetAdStrengthAndActionItems']
          .$call({
            ad: {
              '@odata.type': '#Model.ResponsiveSearchAd',
              Type: 'ResponsiveSearch',
              adId: this.adId,
              Headlines: getAssets(headlines),
              Descriptions: getAssets(descriptions),
            },
          })
          .toJSON(),
      },
    };
    const options = {
      cacheResponse: false,
    };
    return this.jsdata.Ad.findAll(params, options);
  }
}
